// Imágenes de cada sección (logo, líneas decorativas y fondo de la card)
import identidad_logo from "../../global/imagenes/proyecto_vida/identidad_logo.png";
import identidad_lines from "../../global/imagenes/proyecto_vida/identidad_lines.png";
import identidad_card from "../../global/imagenes/proyecto_vida/identidad_card.png";
import identidad_card_detail from "../../global/imagenes/proyecto_vida/identidad_card_detail.png"; 
import proyeccion_logo from "../../global/imagenes/proyecto_vida/proyeccion_logo.png";
import proyeccion_lines from "../../global/imagenes/proyecto_vida/proyeccion_lines.png";
import proyeccion_card from "../../global/imagenes/proyecto_vida/proyeccion_card.png";
import proyeccion_card_detail from "../../global/imagenes/proyecto_vida/proyeccion_card_detail.png";
import fortalezas_logo from "../../global/imagenes/proyecto_vida/fortalezas_logo.png";
import fortalezas_lines from "../../global/imagenes/proyecto_vida/fortalezas_lines.png";
import fortalezas_card from "../../global/imagenes/proyecto_vida/fortalezas_card.png";
import fortalezas_card_detail from "../../global/imagenes/proyecto_vida/fortalezas_card_detail.png";
import crecimiento_logo from "../../global/imagenes/proyecto_vida/crecimiento_logo.png";
import crecimiento_lines from "../../global/imagenes/proyecto_vida/crecimiento_lines.png";
import crecimiento_card from "../../global/imagenes/proyecto_vida/crecimiento_card.png";
import crecimiento_card_detail from "../../global/imagenes/proyecto_vida/crecimiento_card_detail.png";
import oportunidades_logo from "../../global/imagenes/proyecto_vida/oportunidades_logo.png";
import oportunidades_lines from "../../global/imagenes/proyecto_vida/oportunidades_lines.png";
import oportunidades_card from "../../global/imagenes/proyecto_vida/oportunidades_card.png";
import oportunidades_card_detail from "../../global/imagenes/proyecto_vida/oportunidades_card_detail.png";
import retos_logo from "../../global/imagenes/proyecto_vida/retos_logo.png";
import retos_lines from "../../global/imagenes/proyecto_vida/retos_lines.png";
import retos_card from "../../global/imagenes/proyecto_vida/retos_card.png";
import retos_card_detail from "../../global/imagenes/proyecto_vida/retos_card_detail.png";

// Longitud máxima del texto de cada sección
export const MAX_CARACTERES = 500;

export const SECCIONES = [
  {
    key: "identidad",
    titulo: "Mi identidad",
    descripcionCard: "Explora tus vínculos, pasiones, valores e intereses.",
    descripcionModal:
      "Reflexiona sobre quién eres e identifica los vínculos, pasiones, valores e intereses más importantes.",
    consejo:
      "Explora lo que te define, los valores que guían tus decisiones y la persona que quieres llegar a ser.",
    placeholder: "Escribe aquí quién eres...",
    color: "#7E57C2",
    logo: identidad_logo,
    lines: identidad_lines,
    card: identidad_card,
    cardDetail: identidad_card_detail,
  },
  {
    key: "proyeccion",
    titulo: "Mi proyección",
    descripcionCard: "Define tu visión, misión y propósito.",
    descripcionModal:
      "Piensa hacia dónde quieres ir y define la visión, misión y propósito que guiarán tu proyecto de vida.",
    consejo:
      "Imagina dónde te ves a futuro y qué huella quieres dejar; eso dará dirección a tus decisiones.",
    placeholder: "Escribe aquí tu visión...",
    color: "#2E9E5B",
    logo: proyeccion_logo,
    lines: proyeccion_lines,
    card: proyeccion_card,
    cardDetail: proyeccion_card_detail,
  },
  {
    key: "fortalezas",
    titulo: "Mis fortalezas",
    descripcionCard: "Identifica tus habilidades, talentos, capacidades y recursos.",
    descripcionModal:
      "Reconoce las habilidades, talentos, capacidades y recursos con los que ya cuentas.",
    consejo:
      "Piensa en aquello que haces bien y en lo que otros valoran de ti; son tu punto de partida.",
    placeholder: "Escribe aquí tus fortalezas...",
    color: "#F5B301",
    logo: fortalezas_logo,
    lines: fortalezas_lines,
    card: fortalezas_card,
    cardDetail: fortalezas_card_detail,
  },
  {
    key: "crecimiento",
    titulo: "Mi crecimiento",
    descripcionCard: "Reconoce los aspectos que quieres desarrollar y mejorar.",
    descripcionModal:
      "Identifica los aspectos personales y profesionales que quieres desarrollar y mejorar.",
    consejo:
      "Sé honesto contigo mismo: reconocer lo que quieres mejorar es el primer paso para lograrlo.",
    placeholder: "Escribe aquí lo que quieres mejorar...",
    color: "#1E6FD9",
    logo: crecimiento_logo,
    lines: crecimiento_lines,
    card: crecimiento_card,
    cardDetail: crecimiento_card_detail,
  },
  {
    key: "oportunidades",
    titulo: "Mis oportunidades",
    descripcionCard: "Descubre las posibilidades y recursos del entorno que puedes aprovechar.",
    descripcionModal:
      "Explora las posibilidades y recursos de tu entorno que puedes aprovechar para avanzar.",
    consejo:
      "Mira a tu alrededor: personas, programas y espacios que pueden impulsar tu proyecto de vida.",
    placeholder: "Escribe aquí tus oportunidades...",
    color: "#D32F2F",
    logo: oportunidades_logo,
    lines: oportunidades_lines,
    card: oportunidades_card,
    cardDetail: oportunidades_card_detail,
  },
  {
    key: "retos",
    titulo: "Mis retos",
    descripcionCard: "Identifica los obstáculos que pueden dificultar tu proyecto y cómo afrontarlos.",
    descripcionModal:
      "Identifica los obstáculos que pueden dificultar tu proyecto de vida y cómo planeas afrontarlos.",
    consejo:
      "Anticipar las dificultades te permite prepararte y trazar un plan para superarlas.",
    placeholder: "Escribe aquí tus retos...",
    color: "#2E7D32",
    logo: retos_logo,
    lines: retos_lines,
    card: retos_card,
    cardDetail: retos_card_detail,
  },
];

// Estructura vacía del formulario (frase + las 6 secciones)
export const PROYECTO_VACIO = {
  frase: "",
  identidad: "",
  proyeccion: "",
  fortalezas: "",
  crecimiento: "",
  oportunidades: "",
  retos: "",
};

/* -------------------------------------------------------------------------- */
/*  Gestión (Consulta y seguimiento)                                          */
/* -------------------------------------------------------------------------- */

// Genérica de programas académicos
export const GENERICA_PROGRAMAS = 5;

// Semestres para el filtro (1..10)
export const SEMESTRES = Array.from({ length: 10 }, (_, i) => i + 1);

// Paleta para el avatar de iniciales
export const COLORES_AVATAR = ["#7E57C2", "#2E9E5B", "#1E6FD9", "#D32F2F", "#F5B301", "#2E7D32", "#00838F", "#8E24AA"];

// Paleta para la nube de palabras (Análisis de información).
// El primer color se asigna a la palabra más frecuente (dorado, como en el diseño).
export const COLORES_NUBE = ["#F5B301", "#2E9E5B", "#7E57C2", "#D32F2F", "#1E6FD9", "#00838F", "#EF6C00", "#8E24AA"];
